export interface ClientDetail {
  client_uniqeid: string;
  cmp_address1: string;
  cmp_address2: string;
  cmp_archive_status: string;
  cmp_city: string;
  cmp_contact: string;
  cmp_country: string;
  cmp_creation_date: string | Date;
  cmp_emailid: string;
  cmp_industry: string;
  client_gstNumber: string;
  cmp_last_modified: string | Date;
  cmp_name: string;
  cmp_pincode: string;
  cmp_state: string;
  company_id: string;
  limit?: number;
  offset?: number;
  total_records?: number
}

export interface AddClient {
  cmp_name: string;
  cmp_emailid: string;
  cmp_contact: string;
  cmp_industry: string;
  gstNumber: string;
  cmp_address1: string;
  cmp_address2: string;
  cmp_country: string;
  cmp_state: string;
  cmp_city: string;
  cmp_pincode: string;
  company_id?: string;
}

export interface AddSubClient {
  user_id: string;
  usr_role_track_id: string;
  token: string;
  company_id: string;
  subCompany_name: string;
  billing_address1: string;
  billing_address2: string;
  country: string;
  state: string;
  city: string;
  postal_code: string;
  industry_type: string;
  gstNumber: string;
  email: string;
  contact_no: string;
  Companysub_id?: string;
}

export interface SubClientDetail {
  city: string;
  country: string;
  entity_address: string;
  entity_address2: string;
  entity_archive_status: string;
  entity_cmp_track_id: string;
  entity_creation_date: string | Date;
  entity_email: string;
  entity_id: string;
  entity_last_modified: string | Date;
  entity_name: string;
  entity_phone: string;
  industry_type: string;
  client_gstNumber: string;
  postal_code: string;
  state: string;
  company_name: [{
    company_id: string;
    cmp_name: string;
  }]
  companyName: string;
  [key: string]: any;
  total_record: any;
  limit?: number;
  offset?: number;
}

export interface AddContact {
  user_id: string;
  usr_role_track_id: string;
  token: string;
  company_id: string;
  contactName: string;
  contactEmail: string;
  contactDesignation: string;
  contactMobile: string;
  contactLandline: string;
  contactLandlineExt: string;
  Companycontact_id?: string;
  Contact_archive_status?: boolean;
}

export interface ContactDetail {
  client_id: string;
  client_name: string;
  contactDesignation: string;
  contactEmail: string;
  contactLandline: string;
  contactLandlineExt: string;
  contactMobile: string;
  contactName: string;
  contact_id: string;
  createdOn: string;
  status: string;
  sub_clientId: string;
  updatedOn: string;
  srNo: number;
  entity_id: string;
  [key: string]: any;
  limit?: number,
  offset?: number
}